"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsroomContextProvider = exports.NewsroomContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const react_1 = require("react");
exports.NewsroomContext = (0, react_1.createContext)(undefined);
/**
 * This context provides common Newsroom information retrieved by `getNewsroomServerSideProps` helper.
 * Please refer to the `NewsroomContextType` definition for more info on what's exposed from the context.
 */
function NewsroomContextProvider({ categories, contacts, newsroom, currentCategory, currentGallery, currentStory, companyInformation, languages, localeCode, notifications, themePreset, searchSettings, children, }) {
    const locale = (0, react_1.useMemo)(() => theme_kit_core_1.LocaleObject.fromAnyCode(localeCode || theme_kit_core_1.DEFAULT_LOCALE), [localeCode]);
    return ((0, jsx_runtime_1.jsx)(exports.NewsroomContext.Provider, { value: {
            categories,
            contacts,
            newsroom,
            currentCategory,
            currentGallery,
            currentStory,
            companyInformation,
            languages,
            locale,
            notifications,
            themePreset,
            searchSettings,
        }, children: children }));
}
exports.NewsroomContextProvider = NewsroomContextProvider;
//# sourceMappingURL=context.js.map